import { Instagram, ShoppingBag, ArrowUp } from "lucide-react";
import { SITE } from "@/data/site";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52V7.08a4.85 4.85 0 0 1-1.84-.39Z"/>
  </svg>
);
const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.667 5.452l-.999 3.648 3.821-.799z"/></svg>
);

const LINKS = [
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "hikayemiz", label: "Hikâyemiz" },
  { id: "urunler", label: "Ürünler" },
  { id: "koleksiyonlar", label: "Koleksiyonlar" },
  { id: "sss", label: "SSS" },
  { id: "odeme", label: "Ödeme Bilgileri" },
  { id: "iletisim", label: "İletişim" },
];

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="footer-ink relative overflow-hidden" data-testid="footer">
      <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-[hsl(var(--nl-champagne)/0.08)] blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo-dark.jpg" alt="NovaLand" className="h-14 w-14 rounded-full object-cover ring-1 ring-[hsl(var(--nl-champagne)/0.4)]" />
              <div>
                <p className="font-display text-2xl tracking-wide">{SITE.brand}</p>
                <p className="text-[11px] uppercase tracking-[0.3em] text-[hsl(var(--nl-champagne))]">Aksesuar &amp; Takı</p>
              </div>
            </div>
            <p className="font-serif italic text-2xl mt-7 leading-snug text-[hsl(var(--nl-cream))]/95">
              &ldquo;{SITE.tagline}&rdquo;
            </p>
            <p className="text-sm text-[hsl(var(--nl-cream))]/60 mt-5 max-w-md leading-relaxed">
              NovaLand — kolye, küpe, bileklik, yüzük ve halhal modellerinde kalite ve zarafetin
              buluştuğu adres.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow !text-[hsl(var(--nl-champagne))]">Hızlı Bağlantılar</p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-sm text-[hsl(var(--nl-cream))]/75 hover:text-[hsl(var(--nl-champagne))] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow !text-[hsl(var(--nl-champagne))]">İletişim & Sosyal</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <WhatsAppIcon size={16} />
                <a href={`https://wa.me/${SITE.whatsapp.number}`} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--nl-cream))]/85 hover:text-[hsl(var(--nl-champagne))]">
                  {SITE.whatsapp.display}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={16} />
                <a href={SITE.social.instagram} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--nl-cream))]/85 hover:text-[hsl(var(--nl-champagne))]">
                  {SITE.social.instagramHandle}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <TikTokIcon size={16} />
                <a href={SITE.social.tiktok} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--nl-cream))]/85 hover:text-[hsl(var(--nl-champagne))]">
                  {SITE.social.tiktokHandle}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <ShoppingBag size={16} />
                <a href={SITE.social.shopier} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--nl-cream))]/85 hover:text-[hsl(var(--nl-champagne))]">
                  Shopier Mağaza
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[hsl(var(--nl-cream))]/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="text-xs text-[hsl(var(--nl-cream))]/55">
              © 2026 NovaLand. Tüm Hakları Saklıdır.
            </p>
            <p className="text-[11px] text-[hsl(var(--nl-champagne))]/80 mt-1.5 tracking-[0.18em] uppercase" data-testid="footer-credit">
              Serdar Ceylan
            </p>
          </div>
          <button
            data-testid="footer-scroll-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[hsl(var(--nl-cream))]/70 hover:text-[hsl(var(--nl-champagne))]"
          >
            Yukarı Çık <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
